import { API_ENDPOINTS, apiClient } from './config.js';

/**
 * 课程报名相关API
 */

// 获取用户的报名记录
export const getUserEnrollments = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.COURSE_ENROLLMENT.LIST);
    return response;
  } catch (error) {
    console.error('获取用户报名记录失败:', error);
    throw error;
  }
};

// 获取可报名的课程列表
export const getAvailableCourses = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.COURSE_ENROLLMENT.COURSES);
    return response;
  } catch (error) {
    console.error('获取课程列表失败:', error);
    throw error;
  }
};

// 提交课程报名
export const submitEnrollment = async (enrollmentData) => {
  try {
    const response = await apiClient.post(API_ENDPOINTS.COURSE_ENROLLMENT.CREATE, enrollmentData);
    return response;
  } catch (error) {
    console.error('课程报名提交失败:', error);
    throw error;
  }
};

// 管理员获取所有报名记录
export const getAllEnrollments = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.COURSE_ENROLLMENT.ADMIN_LIST);
    return response;
  } catch (error) {
    console.error('获取所有报名记录失败:', error);
    throw error;
  }
};

// 管理员更新报名状态
export const updateEnrollmentStatus = async (enrollmentId, statusData) => {
  try {
    const response = await apiClient.put(
      API_ENDPOINTS.COURSE_ENROLLMENT.ADMIN_UPDATE(enrollmentId), 
      statusData
    );
    return response;
  } catch (error) {
    console.error('更新报名状态失败:', error);
    throw error;
  }
};

// 管理员删除报名记录
export const deleteEnrollment = async (enrollmentId) => {
  try {
    const response = await apiClient.delete(
      API_ENDPOINTS.COURSE_ENROLLMENT.ADMIN_DELETE(enrollmentId)
    );
    return response;
  } catch (error) {
    console.error('删除报名记录失败:', error);
    throw error;
  }
};

// 课程分类和子分类的映射关系
export const COURSE_CATEGORIES = {
  kids: {
    name: '子ども向け英語クラス',
    subcategories: null
  },
  senior: {
    name: 'シニア向け英会話',
    subcategories: null
  },
  eiken: {
    name: '英検対策クラス',
    subcategories: {
      '5kyu': '5級以上',
      '4kyu': '4級以上',
      '3kyu': '3級以上',
      'jun2kyu': '準2級以上',
      'jun2kyu_plus': '準2級プラス以上',
      '2kyu': '2級以上'
    }
  }
};

// 状态映射
export const ENROLLMENT_STATUS = {
  pending: '審査中',
  approved: '承認済み',
  rejected: '拒否'
};

// 获取课程显示名称
export const getCourseDisplayName = (category, subcategory = null) => {
  const categoryInfo = COURSE_CATEGORIES[category];
  if (!categoryInfo) return '不明なコース';
  
  if (subcategory && categoryInfo.subcategories) {
    const subcategoryName = categoryInfo.subcategories[subcategory];
    return `${categoryInfo.name} - ${subcategoryName}`;
  }
  
  return categoryInfo.name;
};

// 获取状态显示名称
export const getStatusDisplayName = (status) => {
  return ENROLLMENT_STATUS[status] || status;
}; 